/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/link-arrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#242424" d="M11 11V5l1-1 4 4-4 4-1-1zM0 7h11v2H0V7z"/>'
  }
})
